module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.src) ? _c('section', {
    staticClass: "flex-column",
    on: {
      "mouseover": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [_c('div', {
    staticClass: "video-inner-container"
  }, [_c('video', {
    ref: "video",
    staticClass: "video",
    class: {
      'player-height': !_vm.narrowVideoMode, 'player-height-narrow': _vm.narrowVideoMode
    },
    attrs: {
      "oncontextmenu": "return false;",
      "preload": "",
      "src": _vm.src,
      "controls": _vm.mobile
    },
    on: {
      "click": function($event) {
        _vm.togglePlay()
      },
      "canplay": function($event) {
        _vm.videoLoaded($event)
      },
      "timeupdate": function($event) {
        _vm.videoTimeUpdate($event)
      },
      "progress": function($event) {
        _vm.updateBuffer($event)
      },
      "pause": function($event) {
        _vm.paused = true
      },
      "playing": function($event) {
        _vm.paused = false
      }
    }
  }), _vm._v(" "), (!_vm.mobile) ? _c('div', {
    staticClass: "video-controls-container",
    class: _vm.hovering && 'active'
  }, [_c('div', {
    ref: "progress-bar-container",
    on: {
      "click": _vm.clickProgressBar
    }
  }, [_c('div', {
    staticClass: "progress-bar-container"
  }, [_c('div', {
    ref: "progressBar",
    staticClass: "progress-bar",
    style: ({
      width: _vm.progressWidth + '%'
    })
  }), _vm._v(" "), _c('div', {
    ref: "bufferBar",
    staticClass: "buffer-bar",
    style: ({
      width: _vm.bufferWidth + '%'
    })
  }), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      staticClass: "marker",
      style: ({
        left: (comment.start_time / _vm.duration * 100) + '%'
      })
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "video-controls"
  }, [_c('div', {
    staticClass: "flex-align-center"
  }, [(_vm.duration === _vm.currentTime) ? _c('ReplayIcon', {
    nativeOn: {
      "click": function($event) {
        _vm.replayVideo()
      }
    }
  }) : (_vm.paused) ? _c('SimplePlayIcon', {
    nativeOn: {
      "click": function($event) {
        _vm.playVideo()
      }
    }
  }) : (!_vm.paused) ? _c('PauseIcon', {
    nativeOn: {
      "click": function($event) {
        _vm.pauseVideo()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "timestamp"
  }, [_vm._v("\n          " + _vm._s(_vm._f("prettyCommentTime")(_vm._f("round")(_vm.currentTime))) + " / " + _vm._s(_vm._f("prettyCommentTime")(_vm._f("round")(_vm.duration))) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-align-center"
  }, [_c('JumpBackIcon', {
    nativeOn: {
      "click": function($event) {
        _vm.jumpBack()
      }
    }
  }), _vm._v(" "), _c('JumpForwardIcon', {
    nativeOn: {
      "click": function($event) {
        _vm.jumpForward()
      }
    }
  }), _vm._v(" "), (_vm.muted || _vm.volume == '0') ? _c('MutedIcon', {
    staticClass: "video-control mute",
    nativeOn: {
      "click": function($event) {
        _vm.unMuteVideo()
      }
    }
  }) : _c('SpeakerIcon', {
    nativeOn: {
      "click": function($event) {
        _vm.muteVideo()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.volume),
      expression: "volume"
    }],
    staticClass: "volume-control",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "any"
    },
    domProps: {
      "value": (_vm.volume)
    },
    on: {
      "__r": function($event) {
        _vm.volume = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.handlePlaybackRateChange
    }
  }, [_c('option', [_vm._v("x1")]), _vm._v(" "), _c('option', [_vm._v("x1.5")]), _vm._v(" "), _c('option', [_vm._v("x2")]), _vm._v(" "), _c('option', [_vm._v("x5")])]), _vm._v(" "), _c('FullScreenIcon', {
    nativeOn: {
      "click": function($event) {
        _vm.toggleFullScreen()
      }
    }
  })], 1)])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-60c4edea"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = 1046
// module chunks = 0